import { Tree, Modal } from "antd";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import isEqual from "lodash/isEqual";
import isArray from "lodash/isArray";
import forEach from "lodash/forEach";
import uniq from "lodash/uniq";
import { getLabel } from "../../wea-locale-provider/util";
import WeaTools from "../../wea-tools";
import WeaDialog from "../../wea-dialog";

const TreeNode = Tree.TreeNode;
class Main extends React.Component {
  constructor(props) {
    super(props);
    const { defaultExpandedKeys, treeData } = props;
    this.generateData = generateData.bind(this);
    this.generateTreeNodes = generateTreeNodes.bind(this);
    this.getNewTreeData = getNewTreeData.bind(this);
    this.state = {
      expandedKeys: defaultExpandedKeys || [],
      ztreeExpandedKeys: defaultExpandedKeys || [],
      selectedKeys: [],
      treeData: treeData || [],
      defaultExpandedKeys: defaultExpandedKeys || [],
      checkedKeys: [],
      radioCheckedData: props.radioCheckedData || "",
      checkedDatas: [],
      checkStrictly: props.checkStrictly || false,
      optParams: {}
    };
  }
  componentDidMount() {
    const { isHrmTree } = this.props;
    const { treeData } = this.state;
    const tempExpandedKeys = [...this.state.defaultExpandedKeys];
    !isHrmTree && this.generateData(treeData, 1, tempExpandedKeys);
    if (this.props.asynLoadAll) {
      this.fetchChildDatas();
    } else {
      this.setState({
        treeData: objToArray(treeData),
        defaultExpandedKeys: tempExpandedKeys,
        expandedKeys: tempExpandedKeys
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const { componyParam, isHrmTree } = this.props;
    let { checkStrictly } = this.state;
    const tempExpandedKeys = [...this.state.defaultExpandedKeys];
    if (componyParam && componyParam != nextProps.componyParam) {
      //虚拟维度
      this.generateData(nextProps.treeData);
      this.setState({
        expandedKeys: nextProps.defaultExpandedKeys,
        treeData: objToArray(nextProps.treeData)
      });
    }
    if (!isEqual(this.props.treeData, nextProps.treeData)) {
      //初始树数据
      !isHrmTree && this.generateData(nextProps.treeData, 1, tempExpandedKeys);
      this.setState({
        treeData: objToArray(nextProps.treeData),
        defaultExpandedKeys: tempExpandedKeys,
        expandedKeys: tempExpandedKeys
      });
    }
    if ("checkedDatas" in nextProps && nextProps.checkedDatas != undefined) {
      if (
        !isEqual(this.props.checkedDatas, nextProps.checkedDatas) ||
        !isEqual(this.state.checkedDatas, nextProps.checkedDatas)
      ) {
        //多选数据受控
        let checkedKeys = this.formatCheckDatas(nextProps.checkedDatas);
        this.updateExpandedKeys(checkedKeys, nextProps.defaultExpandedKeys);
        this.setState({
          checkedKeys,
          checkedDatas: nextProps.checkedDatas
        });
      }
    }
    if ("radioCheckedData" in nextProps) {
      if (!isEqual(this.state.radioCheckedData, nextProps.radioCheckedData)) {
        //单选数据受控
        this.setState({ radioCheckedData: nextProps.radioCheckedData });
      }
    }
    if (
      "defaultExpandedKeys" in nextProps &&
      !isEqual(this.props.defaultExpandedKeys, nextProps.defaultExpandedKeys)
    ) {
      //初始展开的树节点
      this.setState({
        defaultExpandedKeys: nextProps.defaultExpandedKeys,
        expandedKeys: nextProps.defaultExpandedKeys
      });
      if (this.state.checkedKeys && this.state.checkedKeys.length > 0) {
        this.updateExpandedKeys(
          this.state.checkedKeys,
          nextProps.defaultExpandedKeys
        );
      }
    }
    if (
      "checkStrictly" in nextProps &&
      !isEqual(checkStrictly, nextProps.checkStrictly)
    ) {
      checkStrictly = nextProps.checkStrictly;
      this.setState({ checkStrictly });
    }
  }
  formatCheckDatas(checkedDatas) {
    let keys = [];
    if (isArray(checkedDatas) && checkedDatas.length > 0) {
      forEach(this.treeDataList, (item, key) => {
        if (checkedDatas.some(d => d.id == item.id && d.name == item.name)) {
          keys.push(key);
        }
      });
    }
    return keys;
  }
  updateExpandedKeys(checkedKeys, expandedKeys) {
    expandedKeys = expandedKeys || this.state.expandedKeys;
    if (isArray(checkedKeys) && checkedKeys.length > 0) {
      let parentIds = [];
      checkedKeys.forEach(k => parentIds.push(this.treeDataList[k].pid));
      forEach(this.treeDataList, (item, key) => {
        if (parentIds.some(d => d == item.id)) {
          expandedKeys.push(key);
        }
      });
    }
    expandedKeys = uniq([...expandedKeys, ...this.state.expandedKeys]);
    this.setState({ expandedKeys });
  }
  onCheck(checkedKeys, e, inCheck = false) {
    const handleCheckedKeys = (cks, env) => {
      const { isMult, checkedCb, checkStrictly } = this.props;
      const checkedKey = env.node.props.treeKey;
      const checked = env.checked;
      if (isMult) {
        let selectNodes = [];
        let ids = [];
        // cks = cks.filter(
        //   k => checkStrictly || k.indexOf(checkedKey + "-") == -1
        // ); // 过滤子节点
        cks.forEach(i => {
          if (!this.isCheckedDisable(this.treeDataList[i])) {
            selectNodes.push(this.treeDataList[i]);
            ids.push(this.treeDataList[i].id);
          }
        });
        checkedCb && checkedCb(ids, selectNodes);
        // if (!this.state.checkStrictly && e.checked && !inCheck) {
        //   this.checkChild(
        //     [this.treeDataList[e.node.props.eventKey]],
        //     1,
        //     0,
        //     true,
        //     e.node.props.eventKey
        //   );
        // }
      }
    };
    if (!inCheck) {
      this.setState({ checkedKeys }, () => handleCheckedKeys(checkedKeys, e));
    } else {
      handleCheckedKeys(checkedKeys, e);
      // const { isMult } = this.props;
      // if (isMult) {
      //   let selectNodes = [];
      //   let ids = [];
      //   checkedKeys.forEach(i => {
      //     if (!this.isCheckedDisable(this.treeDataList[i])) {
      //       selectNodes.push(this.treeDataList[i]);
      //       ids.push(this.treeDataList[i].id);
      //     }
      //   });
      //   this.props.checkedCb && this.props.checkedCb(ids, selectNodes);
      //   // if (!this.state.checkStrictly && e.checked && !inCheck) {
      //   //   this.checkChild(
      //   //     [this.treeDataList[e.node.props.eventKey]],
      //   //     1,
      //   //     0,
      //   //     true,
      //   //     e.node.props.eventKey
      //   //   );
      //   // }
      // }
    }
  }
  onCheckedKeysChange(checkedKeys) {
    const { isMult, onCheckedKeysChange } = this.props;
    if (isMult) {
      let selectNodes = [];
      let ids = [];
      checkedKeys.forEach(i => {
        if (!this.isCheckedDisable(this.treeDataList[i])) {
          selectNodes.push(this.treeDataList[i]);
          ids.push(this.treeDataList[i].id);
        }
      });
      onCheckedKeysChange && onCheckedKeysChange(ids, selectNodes);
    }
  }
  onZTreeCheck(treeIds, treeNodes) {
    this.props.checkedCb && this.props.checkedCb(treeIds, treeNodes);
  }
  resetCheck() {
    this.setState({
      checkedKeys: []
    });
  }
  resetSelect() {
    this.setState({
      selectedKeys: []
    });
  }
  onSelect(keys, e) {
    const { isMult } = this.props;
    if (typeof this.props.onSelect === "function") {
      this.props.onSelect(e);
    }
    if (!isMult) {
      this.setTheDatas(keys, e.selectedNodes);
    }
  }
  onHrmSelect(selectedKeys, nodes) {
    if (nodes && nodes[0] && nodes[0].type === "resource") {
      this.onRadioCheck(nodes);
    }
  }
  onDoubleClick(key) {
    if (this.isCheckedDisable(this.treeDataList[key])) return;
    this.props.onDoubleClick &&
      this.props.onDoubleClick([this.treeDataList[key]]);
  }
  setTheDatas(selectTreeKeys, nodes) {
    let idArr = [];
    let nameArr = [];
    let keys = [];
    nodes = nodes || [];
    for (let i = 0, length = nodes.length; i < length; i++) {
      const node = nodes[i].props;
      if (node.canClick) {
        idArr.push(node.id);
        nameArr.push(node.name);
        keys.push(selectTreeKeys[i]);
      }
    }
    this.setState({
      selectedKeys: keys
    });
    let ids = idArr.join(",");
    let names = nameArr.join(",");
    if (typeof this.props.setData === "function") {
      this.props.setData(ids, names);
    }
  }
  onLoadData(treeNode) {
    let _this = this;
    const { dataUrl, keyword, params } = this.props;
    const browserType = this.props.type;
    const treeData = [...this.state.treeData];
    const {
      eventKey,
      treeKey,
      isVirtual,
      type,
      psubcompanyid,
      id,
      level
    } = treeNode.props;
    // let params = `&type=${type}&id=${id}&isVirtual=${isVirtual}`;//（当前节点是部门的需要传递psubcompanyid）
    // (this.props.type == 4) && (params += '&isLoadSubDepartment=1');//加载部门
    let innerParams =
      browserType == 4
        ? { isLoadSubDepartment: 1, type: type, id: id, isVirtual: isVirtual }
        : { type: type, id: id, isVirtual: isVirtual };
    if (keyword) innerParams.keyword = keyword;
    let searchParams = { ...params, ...innerParams, level: level };
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams)
        .then(datas => {
          this.getNewTreeData(
            treeData,
            treeKey,
            this.generateTreeNodes(datas, treeNode.props.treeKey),
            2
          );
          _this.setState({ treeData });
          let checkedKeys = _this.formatCheckDatas(_this.state.checkedDatas);
          _this.setState({ checkedKeys });
          resolve();
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  }
  checkChild(
    items,
    level,
    defaultExpandedLevel,
    needCheck = false,
    parentKey = ""
  ) {
    items = [...objToArray(items)];
    items.forEach(item => {
      if (!item.treeKey) {
        item.treeKey = parentKey + "-" + item.id;
        if (item.type === "1") {
          item.treeKey += "type1";
        }
      }
      item.children = item.subs || item.children || [];
      if (item.isParent) {
        if (item.children.length == 0 && !item.isLoad) {
          this.fetchChildDataByLevel(
            item,
            level,
            defaultExpandedLevel,
            needCheck,
            item.treeKey
          ).then(() => {
            // this.generateData(item, level)
            let expandedKeys = this.state.expandedKeys;
            let checkedKeys = this.state.checkedKeys;
            if (level <= defaultExpandedLevel || defaultExpandedLevel === 0) {
              expandedKeys.push(item.treeKey);
              if (needCheck) {
                checkedKeys.push(item.treeKey);
                this.onCheck(uniq(checkedKeys), { checked: true }, true);
              }
            }
            // this.setState({treeData: objToArray(items), expandedKeys: expandedKeys, checkedKeys: checkedKeys})
            this.setState({
              expandedKeys: expandedKeys,
              checkedKeys: uniq(checkedKeys)
            });
          });
        }
        if (item.children.length > 0) {
          this.checkChild(
            item.children,
            level + 1,
            defaultExpandedLevel,
            needCheck
          );
        }
      } else {
        if (needCheck) {
          let checkedKeys = this.state.checkedKeys;
          checkedKeys.push(item.treeKey);
          this.onCheck(uniq(checkedKeys), { checked: true }, true);
          this.setState({ checkedKeys: uniq(checkedKeys) });
        }
      }
    });
  }
  fetchChildDataByLevel(
    item,
    level,
    defaultExpandedLevel,
    needCheck = false,
    parentKey
  ) {
    const { dataUrl, keyword, params } = this.props;
    const browserType = this.props.type;
    const { isVirtual, type, id } = item;
    let innerParams = { type: type, id: id, isVirtual: isVirtual };
    if (browserType == 4) innerParams.isLoadSubDepartment = 1;
    if (keyword) innerParams.keyword = keyword;
    let searchParams = { ...params, ...innerParams };
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams)
        .then(datas => {
          item.children = datas.datas;
          item.isLoad = true;

          const treeData = [...this.state.treeData];
          this.getNewTreeData(
            treeData,
            parentKey,
            this.generateTreeNodes(datas, parentKey)
          );
          this.setState({ treeData });
          let checkedKeys = this.formatCheckDatas(this.state.checkedDatas);
          this.setState({ checkedKeys });

          this.checkChild(
            item.children,
            level + 1,
            defaultExpandedLevel,
            needCheck,
            parentKey
          );
          resolve();
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  }
  fetchChildDatas() {
    const treeData = [...this.state.treeData];
    const defaultExpandedLevel = parseInt(this.props.defaultExpandedLevel) || 1;
    let currentLevel = 1;

    if (treeData) {
      this.checkChild(treeData, currentLevel, defaultExpandedLevel);
    } else {
      return false;
    }
  }
  isCheckedDisable(item) {
    const { filterData, inputId, inputName, checkStrictly } = this.props;
    if (
      !item.canClick &&
      !(
        !checkStrictly &&
        // item.treeKey &&
        // item.treeKey.indexOf("type1") !== -1 &&
        item.isParent
      )
    ) {
      return true;
    }
    if (!isEmpty(filterData)) {
      let id = inputId || "id";
      let name = inputName || "name";
      return filterData.some(
        d =>
          item.id === d[id] &&
          (item.name === d[name] || item.orgWholePathspan === d[name])
      );
    }
    return false;
  }
  isRadioDisable(item) {
    return !item.canClick || false;
  }
  isRadioChecked(item) {
    let bool = false;
    const { radioCheckedData } = this.state;
    if (!isEmpty(radioCheckedData)) {
      if (isString(radioCheckedData)) {
        bool = item.treeKey == radioCheckedData;
      } else {
        bool = item.id == radioCheckedData.id;
      }
    }
    return bool;
  }
  onExpandChange(expandedKeys, nodeObj) {
    this.setState({
      expandedKeys: expandedKeys,
      ztreeExpandedKeys: expandedKeys
    });
  }
  onRadioCheck(key) {
    const { ztreeMode, setRadioData } = this.props;
    let data = null;
    if (ztreeMode && key && key.length > 0) {
      data = key[0];
    } else if (key) {
      data = this.treeDataList[key];
    }
    if (data) {
      this.setState({ radioCheckedData: data });
      setRadioData &&
        setRadioData(
          data.id,
          data.orgWholePathspan || data.name || data.lastname,
          data
        );
    } else {
      this.setState({ radioCheckedData: null });
      setRadioData && setRadioData("", "", null);
    }
  }
  opsHandler = (ops, e, item) => {
    const { dataParams = {} } = this.props;
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    let optParams = {};
    if (ops == "delete") {
      Modal.confirm({
        title: getLabel(131329, "信息确认"),
        content: getLabel(385625, "确定要删除选择的记录吗？"),
        onOk: () => {
          WeaTools.callApi("/api/hrm/group/delete", "POST", {
            cmd: "base",
            groupid: item.id,
            f_weaver_belongto_userid: dataParams.f_weaver_belongto_userid || ""
          })
            .then(res => {
              if (res.status === "1") {
                const { getGrouptree } = this.props;
                getGrouptree && getGrouptree();
              }
            })
            .catch(e => this.props.onError && this.props.onError(e));
        }
      });
    } else {
      optParams = {
        ops: ops,
        groupId: item.id,
        groupType: item.isPrivate === "true" ? 0 : 1,
        visible: true
      };
    }
    this.setState({ optParams });
  };
  getHrmDialog = () => {
    const { icon, iconBgcolor, dataParams = {} } = this.props;
    const { optParams } = this.state;
    const { groupType, groupId, visible = false, ops } = optParams;
    let dialogProps = {
      icon,
      iconBgcolor,
      visible
    };
    const cancelHandler = () => this.setState({ optParams: {} });
    if (ops == "advice") {
      const adviceGroupUrl = `/spa/hrm/static/index.html#/main/hrm/groupAdvice?groupId=${groupId}`;
      // 公共组调整建议弹框
      dialogProps = {
        ...dialogProps,
        title: getLabel("126253", "公共组调整建议"),
        style: { width: 650, height: 360 },
        url: adviceGroupUrl,
        onCancel: cancelHandler,
        callback: cancelHandler
      };
    } else if (ops == "add" || ops == "edit") {
      const fId = dataParams.f_weaver_belongto_userid || "";
      const createGroupUrl = `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupType=${groupType}`;
      const editGroupUrl = `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupId=${groupId}`;
      let groupUrl = ops == "add" ? createGroupUrl : editGroupUrl;
      if (fId) groupUrl += `&f_weaver_belongto_userid=${fId}`;
      // 新建 编辑常用组弹框
      dialogProps = {
        ...dialogProps,
        title:
          ops == "add"
            ? getLabel("386496", "新建常用组")
            : getLabel("126252", "常用组设置"),
        style:
          ops == "add"
            ? { width: 650, height: 225 }
            : { width: 750, height: 482 },
        url: groupUrl,
        onCancel: cancelHandler,
        callback: () =>
          this.setState({
            optParams: groupType ? { ...optParams, ops: "edit" } : {}
          })
      };
    }
    return <WeaDialog {...dialogProps} />;
  };
  getHrmTitle = item => {
    const { icon, iconBgcolor, hasRight } = this.props;
    let title;
    if (item.type == "com") {
      title = (
        <div>
          {typeof icon === "string" ? <span className={icon} /> : icon}
          {item.lastname}
          <span className="wea-f12" style={{ color: "#979797" }}>
            {/*人数占位*/}
          </span>
        </div>
      );
    } else if (item.type == "subcom") {
      title = (
        <div>
          <i className="icon-process-scene" />
          {item.lastname}
        </div>
      );
    } else if (item.type == "dept") {
      title = (
        <div>
          <i className="icon-mail-folder" /> {item.lastname}
        </div>
      );
    } else if (item.type == "resource") {
      title = (
        <div className="wea-f12">
          <img className="wea-tree-hr-portrait" src={item.icon} alt="img" />
          <span style={{ paddingLeft: 10, color: "#333" }}>
            {item.lastname}
          </span>
          <span style={{ color: "#929390", paddingLeft: 10 }}>
            {item.jobtitlename}
          </span>
        </div>
      );
    } else {
      // add: !item.pid存在 父节点 && (私人组 || 有权限的公共组  (isPrivate并不是都有这个参数))
      // edit: item.pid 子节点 && (私人组 || 有权限的公共组)
      // advice: item.pid 子节点 && 没有权限的公共组（可以提交调整公共组建议）
      const canAdd =
        !item.pid &&
        (item.isPrivate === "true" ||
          (item.isPrivate === "false" && hasRight === 1));
      let canEdit = false;
      if (item.canEdit) {
        canEdit =
          item.pid &&
          (item.isPrivate === "true" ||
            (item.isPrivate === "false" && item.canEdit === "true"));
      } else {
        canEdit =
          item.pid &&
          (item.isPrivate === "true" ||
            (item.isPrivate === "false" && hasRight === 1));
      }
      const canAdvice =
        item.pid && item.isPrivate === "false" && hasRight !== 1;
      title = (
        <div>
          <i className={item.cusIcon || "icon-process-scene"} />
          {item.cusIcon ? (
            <span style={{ paddingLeft: 10 }}>{item.lastname}</span>
          ) : (
            item.lastname
          )}
          <span className="wea-tree-hr-node">
            {canAdd && (
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel("611", "添加")}
                onClick={e => this.opsHandler("add", e, item)}
              >
                <i className="icon-coms-Add-to" />
              </span>
            )}
            {canEdit && [
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel("26473", "编辑")}
                onClick={e => this.opsHandler("edit", e, item)}
              >
                <i className="icon-coms-edit" />
              </span>,
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel(91, "删除")}
                onClick={e => this.opsHandler("delete", e, item)}
              >
                <i className="icon-coms-delete" />
              </span>
            ]}
            {canAdvice && (
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel(16159, "建议")}
                onClick={e => this.opsHandler("advice", e, item)}
              >
                <i className="icon-coms-Advice" />
              </span>
            )}
          </span>
        </div>
      );
    }
    return title;
  };
  getTitle = item => {
    const { isLoadUser, renderItem } = this.props;
    let title = (
      <div title={item.title || item.name || item.lastname}>
        {item.icon ? (
          <i className={item.icon} style={{ marginRight: "5px" }} />
        ) : (
          ""
        )}
        {item.displayName || item.name || item.lastname}
      </div>
    );
    if (isLoadUser && item.type == "3") {
      title = (
        <div style={{ position: "relative", paddingLeft: 30 }}>
          <img
            className="wea-tree-hr-portrait"
            style={{
              width: 30,
              height: 30,
              padding: 1,
              position: "absolute",
              top: 1,
              left: 1
            }}
            src={item.icon}
            alt="portrait"
          />
          <span style={{ paddingLeft: 10 }}>
            {item.displayName || item.name || item.lastname}
          </span>
        </div>
      );
    }
    if (item.isImgIcon) {
      title = (
        <div className="wea-f12">
          <img
            className="wea-tree-hr-portrait"
            src={item.icon}
            onError={() =>
              (item.icon =
                "/cloudstore/resource/pc/com/images/portrait_default.jpg")
            }
            alt="img"
          />
          <span style={{ paddingLeft: 10 }}>
            {item.displayName || item.name || item.lastname}
          </span>
        </div>
      );
    }
    if (renderItem) {
      title = renderItem(item);
    }
    return title;
  };
  render() {
    const {
      treeData,
      expandedKeys,
      defaultExpandedKeys,
      selectedKeys,
      checkedKeys,
      checkStrictly,
      radioCheckedData,
      checkedDatas,
      ztreeExpandedKeys
    } = this.state;
    const {
      browserTree,
      isMult,
      hasRadio,
      isLoadAll = false,
      ztreeMode,
      isHrmTree
    } = this.props;
    const loop = (data, level) =>
      data.map(item => {
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            item.children[i].treeKey = `${item.treeKey}-${item.children[i].id}`;
            if (item.children[i].type === "1") {
              item.children[i].treeKey += "type1";
            }
            // item.children[i].isParent ? (item.children[i].isLeaf = false) : (item.children[i].isLeaf = true);
          }
        }
        item.isLeaf = !item.isParent;
        this.treeDataList[item.treeKey] = item;
        return (
          <TreeNode
            browserTree={browserTree}
            level={level}
            isVirtual={item.isVirtual}
            type={item.type}
            title={this.getTitle(item)}
            name={item.name}
            key={item.treeKey}
            id={item.id}
            treeKey={item.treeKey}
            isLeaf={item.isLeaf}
            disableCheckbox={this.isCheckedDisable(item)}
            disableRadio={this.isRadioDisable(item)}
            radioChecked={this.isRadioChecked(item)}
            expanded={true}
            canClick={item.canClick}
          >
            {item.children && loop(item.children, level + 1)}
          </TreeNode>
        );
      });
    this.treeDataList = {};
    const treeNodes = treeData.length > 0 ? loop(treeData, 0) : null;
    let ztreeProps = {};
    if (ztreeMode) {
      ztreeProps = {
        checkable: true,
        ztreeMode,
        browserTree: false,
        onCheck: (isMult
          ? this.onZTreeCheck
          : (treeId, treeNode) => this.onRadioCheck(treeNode)
        ).bind(this),
        onSelect: (isHrmTree ? this.onHrmSelect : this.onSelect).bind(this),
        getTitle: isHrmTree ? this.getHrmTitle : this.getTitle,
        checkedKeys: isMult
          ? (checkedDatas || []).map(d => d.id)
          : radioCheckedData && radioCheckedData.id
          ? [radioCheckedData.id]
          : [],
        expandedKeys: ztreeExpandedKeys,
        checkStrictly: isMult ? checkStrictly : false
      };
    }
    return [
      <Tree
        {...this.props}
        className={`${this.props.className || ""} my-tree`}
        defaultExpandedKeys={defaultExpandedKeys}
        expandedKeys={expandedKeys}
        onExpand={this.onExpandChange.bind(this)}
        onSelect={this.onSelect.bind(this)}
        onCheck={this.onCheck.bind(this)}
        loadData={isLoadAll ? null : this.onLoadData.bind(this)}
        checkable={isMult}
        checkedKeys={checkedKeys}
        checkStrictly={checkStrictly}
        onRadioCheck={this.onRadioCheck.bind(this)}
        hasRadio={hasRadio}
        multiple={isMult}
        selectedKeys={selectedKeys}
        needExpandChildren
        clickNodeExpandChildren={!hasRadio && !isMult}
        onDoubleClick={this.onDoubleClick.bind(this)}
        // autoExpandParent={false}
        {...ztreeProps}
      >
        {!ztreeMode && treeNodes}
      </Tree>,
      isHrmTree && this.getHrmDialog()
    ];
  }
}

function objToArray(obj) {
  if (!isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return obj;
}

function generateData(data, level = 1, defaultExpandedKeys = []) {
  if (!isEmpty(data)) {
    const { topPrefix, defaultExpandedLevel } = this.props;
    if (!isArray(data)) {
      data.isLeaf = !data.isParent;
      if (level == 1) data.treeKey = `${topPrefix}0-${data.id}`;
      data.children = data.subs || data.children;
      if (defaultExpandedLevel > 0 && defaultExpandedLevel >= level) {
        defaultExpandedKeys.push(data.treeKey || data.id);
      }
      if (data.children && data.children.length > 0)
        this.generateData(data.children, level + 1, defaultExpandedKeys);
    } else {
      data.forEach(item => {
        item.isLeaf = !item.isParent;
        if (level == 1) item.treeKey = `${topPrefix}0-${item.id}`;
        item.children = item.subs || data.children;
        if (defaultExpandedLevel > 0 && defaultExpandedLevel >= level) {
          defaultExpandedKeys.push(item.treeKey || item.id);
        }
        if (item.children && item.children.length > 0)
          this.generateData(item.children, level + 1, defaultExpandedKeys);
      });
    }
  }
}

function generateTreeNodes(data, treeKey) {
  let datas = data;
  if (!data.length) {
    datas = new Array(datas);
  }
  let arr = new Array();
  const { topPrefix } = this.props;
  if (!treeKey) {
    for (let i = 0; i < datas.length; i++) {
      const data = datas[i];
      data.treeKey = `${topPrefix}0-${data.id}`;
      data.isLeaf = !data.isParent;
      data.children = data.subs;
      arr.push(data);
    }
  } else {
    const loop = datas => {
      for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        data.treeKey = `${treeKey}-${data.id}`;
        if (data.type === "1") {
          data.treeKey += "type1";
        }
        data.isLeaf = !data.isParent;
        arr.push(data);
      }
    };
    loop(datas[0].datas);
  }
  return arr;
}

function getNewTreeData(treeData, curKey, child, level) {
  const loop = data => {
    data.forEach(item => {
      if ((curKey + "-").indexOf(item.treeKey + "-") === 0) {
        if (!isEmpty(item.children)) {
          loop(item.children);
        } else {
          item.children = child;
        }
      }
    });
  };
  loop(treeData);
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-single-tree/WeaBrowserTree.js